import { Component, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/map';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { CadetapplicationpreviewService } from '../_services/cadetapplicationpreview.service';
import 'rxjs/Rx';
import { environment } from '../../environments/environment';

@Component({
  selector: 'app-cadetpreviewapplicationform',
  templateUrl: './cadetpreviewapplicationform.component.html',
  styleUrls: ['./cadetpreviewapplicationform.component.css']
})
export class CadetpreviewapplicationformComponent implements OnDestroy {
  cadetData;
  submitDataResponse;
  cadetSubmitForm: FormGroup;
  subscription: Subscription;
  currentEmplyYes;
  jobTermSelectionYes;
  militaryServSelectionYes;
  otherSelectedDischarge;
  auxPoliceSelectionYes;
  volEmsFireSelectionYes;
  fdnyExpPrgmSelectionYes;
  fdnyHSSelectionYes;
  fdnyYEASelectionYes;
  comntyVolSelectionYes;
  captchaTestNum1: number;
  captchaTestNum2: number;
  captchaTestAdd: number;
  editflag: boolean;
  checkDup;
  checkDupflag: boolean;
  cadetDupApi;
  cadetApi = environment.baseUrl + "/cadet";
  public capchaEnable = false;
  public akwEnable = false;

  constructor(private fb: FormBuilder, private http: HttpClient, private router: Router, private _CadetapplicationpreviewService: CadetapplicationpreviewService) {
    this.cadetSubmitForm = this.fb.group({
      'selectAcknw': [null, Validators.requiredTrue],
      'captchaGenerated': [null, Validators.required]
    });
  }

  async submitCadetForm(value) {

   
      // this.checkDupflag = false;
      // this.cadetDupApi = "rest/public/cadet_validate/" + value.ssnPers + "/" + value.emailAddrPers;
      
      // this.checkDup = await this.http.get(this.cadetDupApi).toPromise();
      // if (this.checkDup.items.length === 0) {
      //   this.checkDupflag = !this.checkDupflag;
      // }
      // this.cadetDupApi = null;
      //if (this.checkDupflag) {

        let body = '{' +
          '"USCITIZEN":"' + value.usCitizenChooseOne + '",' +
          '"SPECACCOMMNEED":"' + value.saChooseOne + '",' +
          '"FNAMEPERS":"' + value.firstNamePers + '",' +
          '"LNAMEPERS":"' + value.lastNamePers + '",' +
          '"MNAMEPERS":"' + value.middleNamePers + '",' +
          '"SFNAMEPERS":"' + value.suffixNamePers + '",' +
          '"DOBMNTHPERS":"' + value.dobMonthPers + '",' +
          '"DOBDTPERS":"' + value.dobDatePers + '",' +
          '"DOBYRPERS":"' + value.dobYearPers + '",' +
          '"SSN4DIGITSPERS":"' + value.ssnPers + '",' +
          '"STADDPERS":"' + value.strtAddrPers + '",' +
          '"APTPERS":"' + value.aptNumPers + '",' +
          '"CITYPERS":"' + value.cityNamePers + '",' +
          '"STPERS":"' + value.stateNamePers + '",' +
          '"ZIPPERS":"' + value.zipCodePers + '",' +
          '"COUNTRYPERS":"' + value.countryNamePers + '",' +
          '"CELLPERS":"' + value.cellNumPers + '",' +
          '"HOMEPERS":"' + value.homeNumPers + '",' +
          '"EMAILPERS":"' + value.emailAddrPers + '",' +
          '"EDUSELECTEDONE":"' + value.eduChooseOne + '",' +
          '"SCHLNAMEEDU":"' + value.schoolNameEdu + '",' +
          '"SCHADDEDU":"' + value.schoolAddrEdu + '",' +
          '"CITYEDU":"' + value.cityNameEdu + '",' +
          '"STEDU":"' + value.stateNameEdu + '",' +
          '"ZIPEDU":"' + value.zipCodeEdu + '",' +
          '"COUNTRYEDU":"' + value.countryNameEdu + '",' +
          '"YRSPAIDEMPSELECTED":"' + value.yrsPaidEmpSelection + '",' +
          '"YRSEMPSELECTEDOPTION":"' + value.YrsEmpSelectOne + '",' +
          '"INTRNSHIPSELECTED":"' + value.intrnShipSelection + '",' +
          '"INTRNSHIPSELECTEDOPTION":"' + value.intrnShipSelectOne + '",' +
          '"CURRENTEMPLYSELECTED":"' + value.currentEmplySelection + '",' +
          '"CURRENTEMPLYSELECTEDOPTION":"' + value.currentEmplySelectOne + '",' +
          '"CURRENTEMPLYWORKTYPEEDU":"' + value.workTypeEdu + '",' +
          '"JOBTERMSELECTED":"' + value.jobTermSelection + '",' +
          '"JOBTERMREASONMENTIONED":"' + value.jobTermReason + '",' +
          '"MILITARYSERVSELECTED":"' + value.militaryServSelection + '",' +
          '"MILITARYBRANCHSERVED":"' + value.militaryBranchServ + '",' +
          '"MILITARYSERVFROMDATE":"' + value.militaryDateServFrom.month + '/' + value.militaryDateServFrom.day + '/' + value.militaryDateServFrom.year + '",' +
          '"MILITARYSERVTODATE":"' + value.militaryBranchServTo.month + '/' + value.militaryBranchServTo.day + '/' + value.militaryBranchServTo.year + '",' +
          '"DISCHTYPESELECTED":"' + value.dischTypeSelectOne + '",' +
          '"DISCHTYPESELECTEDOTHERREASON":"' + value.dischTypeOtherSelected + '",' +
          '"AUXPOLICESELECTED":"' + value.auxPoliceSelection + '",' +
          '"AUXPOLICEFROMDATE":"' + value.auxPoliceDateFrom.month + '/' + value.auxPoliceDateFrom.day + '/' + value.auxPoliceDateFrom.year + '",' +
          '"AUXPOLICETODATE":"' + value.auxPoliceDateTo.month + '/' + value.auxPoliceDateTo.day + "/" + value.auxPoliceDateTo.year + '",' +
          '"VOLEMSFIRESELECTED":"' + value.volEmsFireSelection + '",' +
          '"VOLEMSFIREFROMDATE":"' + value.volEmsFireDateFrom.month + '/' + value.volEmsFireDateFrom.day + '/' + value.volEmsFireDateFrom.year + '",' +
          '"VOLEMSFIREDATETODATE":"' + value.volEmsFireDateTo.month + '/' + value.volEmsFireDateTo.day + '/' + value.volEmsFireDateTo.year + '",' +
          '"FDNYEXPPRGMSELECTED":"' + value.fdnyExpPrgmSelection + '",' +
          '"FDNYEXPPRGMFROMDATE":"' + value.fdnyExpPrgmDateFrom.month + "/" + value.fdnyExpPrgmDateFrom.day + "/" + value.fdnyExpPrgmDateFrom.year + '",' +
          '"FDNYEXPPRGMTODATE":"' + value.fdnyExpPrgmDateTo.month + "/" + value.fdnyExpPrgmDateTo.day + "/" + value.fdnyExpPrgmDateTo.year + '",' +


          '"FDNYHSSELECTED":"' + value.fdnyHSSelection + '",' +
          '"FDNYHSFROMDATE":"' + value.fdnyHSDateFrom.month + "/" + value.fdnyHSDateFrom.day + "/" + value.fdnyHSDateFrom.year + '",' +
          '"FDNYHSTODATE":"' + value.fdnyHSDateTo.month + "/" + value.fdnyHSDateTo.day + "/" + value.fdnyHSDateTo.year + '",' +

          '"FDNYYEASELECTED":"' + value.fdnyYEASelection + '",' +
          '"FDNYYEAFROMDATE":"' + value.fdnyYEADateFrom.month + "/" + value.fdnyYEADateFrom.day + "/" + value.fdnyYEADateFrom.year + '",' +
          '"FDNYYEATODATE":"' + value.fdnyYEADateTo.month + "/" + value.fdnyYEADateTo.day + "/" + value.fdnyYEADateTo.year + '",' +

          '"COMNTYVOLSELECTED":"' + value.comntyVolSelection + '",' +
          '"COMNTYVOLWORKDESCBRIEF":"' + value.comntyVolWorkDesc + '"' +
          '}';

        this._CadetapplicationpreviewService.passCadetFormData(value);
     
        const headers = new HttpHeaders({ 'Content-Type': 'application/json; charset=utf-8','apikey':environment.apikey});
        this.http.post(this.cadetApi, body, { headers })
          .subscribe(
            (data:any) => {
              if(data.msg){
                alert(data.msg);
              }else{
                this.submitDataResponse = data;
                this._CadetapplicationpreviewService.passCadetConfNumb(this.submitDataResponse);
                this.router.navigate(['applicationconfirmation']);
              }
            },
            error => {
              alert("There was an error processing your request, please try again later.");
            },
            () => {
             
            }
          )
      //} else {
        
      //}
    
  }

  backToEditCadetForm() {
    this.editflag = true;
    this._CadetapplicationpreviewService.passCadetFormData(this.cadetData);
    this._CadetapplicationpreviewService.passEditFlag(this.editflag);
    this.router.navigate(['cadetapplicationform']);
  }

  // re capcha code
  resolved(captchaResponse: string) {
}



  ngOnInit() {
    this.subscription = this._CadetapplicationpreviewService.sharedCadetFormData$.subscribe((res) => this.cadetData = res);
    this.currentEmplyYes = this.cadetData.currentEmplySelection;
    this.jobTermSelectionYes = this.cadetData.jobTermSelection;
    this.militaryServSelectionYes = this.cadetData.militaryServSelection;
    this.otherSelectedDischarge = this.cadetData.dischTypeSelectOne;
    this.auxPoliceSelectionYes = this.cadetData.auxPoliceSelection;
    this.volEmsFireSelectionYes = this.cadetData.volEmsFireSelection;
    this.fdnyExpPrgmSelectionYes = this.cadetData.fdnyExpPrgmSelection;
    this.fdnyHSSelectionYes = this.cadetData.fdnyHSSelection;
    this.fdnyYEASelectionYes = this.cadetData.fdnyYEASelection;
    this.comntyVolSelectionYes = this.cadetData.comntyVolSelection;
    this.captchaTestNum1 = Math.ceil(Math.random() * 10);
    this.captchaTestNum2 = Math.ceil(Math.random() * 10);
    this.captchaTestAdd = this.captchaTestNum1 + this.captchaTestNum2;
    this.editflag = false;
    //this.checkDupflag = false;
  }

  ngAfterViewInit() {
    window.scrollTo(0, 0);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}


// WEBPACK FOOTER //
// ./src/app/cadetpreviewapplicationform/cadetpreviewapplicationform.component.ts